module.exports = __webpack_public_path__ + "img/cs-iosC-1.50b38c1a.jpg";